module.exports = __webpack_public_path__ + "img/053-car.b4f95e83.svg";